// extracted by mini-css-extract-plugin
export default {"inputContainer":"FormStyles_inputContainer__2+oqs"};